import type { Platform } from 'shared/src/domain/line-item/line-item-channels';
import { hasSkillPlatformConfig } from 'shared/src/domain/ai/skills/skill-platform-registry';

export function resolveAssistMePlatforms(platforms: Platform[]): Platform[] {
  return platforms.filter(p => hasSkillPlatformConfig(p.id));
}

export function pickNextPlatform(
  supported: Platform[],
  justCreatedPlatformId: number
): Platform | undefined {
  return supported.find(p => p.id !== justCreatedPlatformId);
}
